import { AuthStore } from '../auth/auth-store';
import { ClientFactory } from '../clients/client-factory';

// eslint-disable-next-line no-undef
const serviceUrl = process.env.REACT_APP_SERVICE_URL as string;
export default new ClientFactory(new AuthStore(), serviceUrl);
